"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformToMap = void 0;
const transformToMap = elements => new Map(elements.map(id => [id, true]));
exports.transformToMap = transformToMap;